import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HelpBoxBadgeComponent } from 'packages/sports/web/app/src/help-box/help-box-badge.component';
import { PriceboostCountSignpostComponent } from 'packages/sports/web/app/src/shared-priceboost/Components/priceboost-count-signpost.component';

import PickOddsComponent from './components/digital/pick-odds.component';

@NgModule({
    imports: [CommonModule, PriceboostCountSignpostComponent, HelpBoxBadgeComponent],
    declarations: [PickOddsComponent],
    exports: [PickOddsComponent],
})
export default class PickOddsModule {}
